export interface Item {
  name: string,
  quantity: number,
  price: string,
  product_id?: string,
}

export interface FormData {
  client_id: string;
  items: Item[];
  description: string,
  custom_name: string,
  custom_email: string,
  days_until_due: number;
}

export const countTotal = (items: any) => {
  const totalInCents = items.reduce(
    (acc, item) => acc + ((item.price || 0).toFixed(2) * 100 * (item.quantity || 0)),
    0,
  );

  if (!totalInCents) return 0;

  const total = (totalInCents / 100);
  return Number.isInteger(total) ? total : total.toFixed(2);
};
